import { isRequired, minLength, maxLength, arrayMinLength, arrayMaxLength, isEmail, minimun, isUrl } from 'validations/defaultMessages';
import * as Yup from 'yup';

const General = {
  basicSchema: Yup.object().shape({
    title: Yup.string()
      .required(isRequired('título do produto'))
      .max(150, maxLength('título do produto', 150))
      .min(5, minLength('título do produto', 5)),
    description: Yup.string()
      .required(isRequired('descrição do produto'))
      .min(100, minLength('descrição do produto', 100))
      .max(4000, maxLength('descrição do produto', 4000)),
    image_id: Yup.mixed().required('A imagem do produto é obrigatória'),
    categories: Yup.array()
      .required('Selecione pelo menos 1 categoria')
      .min(1, arrayMinLength('categoria', 1))
      .max(5, arrayMaxLength('categoria', 5)),
  }),
  detailsSchema: Yup.object().shape({
    launch_date: Yup.string()
      .nullable()
      .when('prelaunch', {
        is: true,
        then: Yup.string().required(isRequired('data de lançamento')),
      }),
    expiration_date: Yup.string()
      .nullable()
      .when('has_expiration_date', {
        is: true,
        then: Yup.string().required(isRequired('data de expiração')),
      }),
    author_name: Yup.string().max(25, maxLength('nome do autor', 25)),
    alternative_url: Yup.string().url(isUrl('url alternativa')),
    friendly_name: Yup.string().max(13, maxLength('Nome exibido na fatura do cartão', 13)),
  }),
  supportRefundSchema: Yup.object().shape({
    support_email: Yup.string().email(isEmail('e-mail de suporte')).required(isRequired('e-mail de suporte')),
    refund_days: Yup.number().required(isRequired('prazo para reembolso')).min(7, minimun('prazo para reembolso', 7)),
  }),
};

export default General;
